import { Node, Path, Point, Range, Transforms } from 'slate';
import getSlateRangeByAnnotationId from 'components/text-editor/hooks/use-custom-editor/actions/get-slate-range-by-annotation-id';
import { ReactEditor } from 'slate-react';

export type DeleteCustomBlock = (
  annotationId: string,
  options?: Options,
) => void;

interface Options {
  at?: Range | Path | Point;
  match?: ((node: Node) => boolean) | undefined;
  mode?: 'highest' | 'lowest';
  split?: boolean | undefined;
  voids?: boolean | undefined;
}

export default function deleteCustomBlock(
  editor: ReactEditor,
): DeleteCustomBlock {
  return function (annotationId: string) {
    const match = (node) => node.annotationId === annotationId;

    const at = getSlateRangeByAnnotationId(editor)(annotationId);

    if (at) {
      Transforms.removeNodes(editor, {
        mode: 'lowest',
        hanging: true,
        match,
        at,
      });
    }
  };
}
